<template>

  <div>
    <w-tool-tip v-if="!isActivable" :label="weet.viewers+' '+$tc('generic.viewer',weet.viewers)" size="small"
                position="right">
      <div class="viewDropdownTrigger">

        <w-icon icon="account-multiple-outline" class="iconView" color="light2"/>

        <div class="numberView"> {{ weet.viewers }}</div>
      </div>
    </w-tool-tip>
    <!-- Viewer -->
    <b-dropdown v-else aria-role="list"
                position="is-top-right"
                @active-change="autoReadViewNotifications"
    >
      <template #trigger>
        <w-tool-tip :label="weet.viewers+' '+$tc('generic.viewer',weet.viewers)" size="small" position="right">
          <div class="viewDropdownTrigger activate">
            <w-icon icon="account-multiple-outline" class="iconView" color="light2"/>
            <div class="numberView"> {{ weet.viewers }}</div>
            <transition name="fade">
              <div class="pastille" v-show="unreadViewNotif"></div>
            </transition>

          </div>
        </w-tool-tip>
      </template>
      <b-dropdown-item custom paddingless>
        <div class="titleViewer">
          {{ weet.viewers + ' ' + $tc('generic.viewer', weet.viewers) }}
        </div>
        <perfect-scrollbar class="psViewer">
          <div v-for="viewer in weetViewers" :key="'weetViewer'+viewer.userID"
               class="tooltipDropdownItem">
            <UserAvatar class="tooltipAvatar"
                        :userAvatar="userImage(viewer)"
                        aria-role="menu"
                        size="small"
                        type="sticker"
            />

            <div class="tooltipViewer">
              <div class="fullNameTooltip">{{ getFullName(viewer) }}</div>
              <transition name="fade">
                <div class="pastille" v-show="isNotificationRead(viewer)"></div>
              </transition>
            </div>
          </div>
          <div v-if="numberOfAnonymousUser" :key="'weetViewer'+'anonymousUser'" class="tooltipDropdownItem">
            <UserAvatar class="tooltipAvatar"
                        aria-role="menu"
                        size="small"
                        type="sticker"
            />
            {{ $tc('generic.anonymou_s') }}
          </div>
        </perfect-scrollbar>
      </b-dropdown-item>

    </b-dropdown>
  </div>
</template>
<script lang="ts">
import {Component, Prop, Vue} from 'vue-property-decorator';
import store from '@/store';
import {Weet} from '@/store/weet/weetModel';
import {User} from '@/store/user/userModel';
import {getUserAvatar} from '@/utils/util';
import WIcon from '@/components/wrapper/w-icon.vue';
import WToolTip from '@/components/wrapper/w-toolTip.vue';
import {canEditThisWeet} from '@/utils/weetUtil';
import UserAvatar from '@/components/user/UserAvatar.vue';
import {LOAD_LAST_WEET_VIEWERS} from '@/store/weetview/weetViewAction';
import {Notification, NotificationType} from '@/store/myNotifications/myNotificationModel';
import {READ_NOTIFICATIONS} from '@/store/myNotifications/myNotificationsAction';
import WButton from '@/components/wrapper/w-button.vue';

@Component({
  components: {
    WButton,
    UserAvatar,
    WToolTip,
    WIcon,
  },
})
export default class WeetViewersTooltip extends Vue {
  @Prop({default: ''})
  public weet!: Weet;


  private isNotificationRead(viewer: User): boolean {
    for (const notification of store.getters.getWeetTypeUnreadNotification) {
      if (notification.weetID === this.weet.weetID
          && notification.type === NotificationType.VIEW_WEET
          && notification.by?.userID === viewer?.userID) {
        return true;
      }
    }
    return false;
  }

  private async autoReadViewNotifications(active: boolean) {
    if (this.canEdit) {
      await store.dispatch(LOAD_LAST_WEET_VIEWERS, {weetID: this.weet.weetID});
      if (active) {
        // When open, Autimatically set the "weet_viewed" notifications to "read" status
        const notificationsToRead: Notification[] = [];
        for (const notification of store.getters.getWeetTypeUnreadNotification) {
          if (notification.weetID === this.weet.weetID && notification.type === NotificationType.VIEW_WEET) {
            notificationsToRead.push(notification);
          }
        }
        if (notificationsToRead.length > 0) {
          this.readNotifications(notificationsToRead);
        }
      }
    }
  }

  private getFullName = ((user: User | null): string => {
    if (user) {
      return (user.firstName || '') + ' ' + (user.lastName || '');
    }
    return '';
  });

  private readNotifications(notifications: Notification[]) {
    store.dispatch(READ_NOTIFICATIONS, notifications);
  }

  get weetViewers(): User[] {
    if (this.canEdit) {
      return store.getters.getWeetViews;
    }
    return [];
  }

  get numberOfAnonymousUser() {
    return this.weet.viewers - this.weetViewers.length;
  }

  get isActivable() {
    return this.canEdit && this.weet.viewers > 0;
  }

  get userConnected(): User {
    return store.getters.userConnected;
  }

  get canEdit(): boolean {
    return canEditThisWeet(this.weet,this.userConnected,false,true);
  }


  get unreadViewNotif(): boolean {
    for (const notification of store.getters.getWeetTypeUnreadNotification) {
      if (notification.weetID === this.weet.weetID && notification.type === NotificationType.VIEW_WEET) {
        return true;
      }
    }
    return false;
  }

  private userImage(user: User): string {
    return getUserAvatar(user, 48);
  }


}
</script>

<style lang="scss" scoped>
@import '@/scss/shadows.scss';

.numberView {
  margin-right: 8px;
  margin-left: 8px;
}

.viewDropdownTrigger {
  display: flex;

  position: relative;
  padding: 4px;
  padding-left: 8px;
  padding-right: 8px;
  border-radius: 8px;
  align-items: center;

  &.activate {
    &:hover {
      cursor: pointer;
      background: whitesmoke;
      //box-shadow: inset 0px 0px 0px 1px var(--light1);
    }
  }

  .iconView {
  }

  .numberView {
    margin-left: 8px;
    margin-right: 0;
  }
}

.pastille {
  width: 12px;
  height: 12px;
  border: solid 2px #FFF;
  border-radius: 12px;
  background: var(--primary);
  animation-delay: 2.5s;
  position: absolute;
  top: -0px;
  left: 0px;
  @extend .shadow1;
}

.iconView {
  margin-right: 4px;
  max-width: 16px;
}

.titleViewer {
  font-size: 14px;
  font-weight: 600;
  color: var(--black);
  width: 100%;
  text-align: center;
  padding-bottom: 8px;
  border-bottom: solid 1px var(--light);
  margin-bottom: 4px;
}

.psViewer {
  max-height: 160px;
  padding-left: 16px;
}

.tooltipDropdownItem {
  display: flex;
  align-items: center;
  margin-top: 8px;
  margin-bottom: 8px;
  max-width: 240px;
  width: 240px;
  position: relative;

  .tooltipAvatar {
    margin-right: 8px;
    max-height: 36px;
  }

  .tooltipViewer {
    display: flex;
    flex-grow: 1;


    .fullNameTooltip {
      flex-grow: 1;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .pastille {
      width: 12px;
      height: 12px;
      border: solid 2px #FFF;
      border-radius: 12px;
      background: var(--primary);
      animation-delay: 2.5s;
      position: absolute;
      top: -4px;
      left: -6px;
      @extend .shadow1;
    }
  }
}


</style>
